// job-post-home.component.ts
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-job-post-home',
  templateUrl: './job-post-home.component.html',
  styleUrls: ['./job-post-home.component.css'],
})
export class JobPostHomeComponent {
  constructor(private router: Router) {}

  goToPostJob() {
    this.router.navigate(['/company-admin/add-job']);
  }

  goToDashboard() {
    this.router.navigate(['/company-admin']);
  }

  howItWorksSteps = [
    {
      number: '1',
      title: 'Create Job Post',
    },
    {
      number: '2',
      title: 'Publish Job',
    },
    {
      number: '3',
      title: 'Receive Applications',
    },
    {
      number: '4',
      title: 'Review Applicants',
    },
    {
      number: '5',
      title: 'Send AI Virtual Interview',
    },
    {
      number: '6',
      title: 'Hire',
    },
  ];

  plans = [
    {
      name: 'Featured Job',
      icon: 'pi pi-star-fill',
      iconColor: '#ef4444',
      iconBg: '#fee2e2',
      description: 'Pin your job post to the top of search\nresults for maximum visibility.',
    },
    {
      name: 'Confidential Job',
      icon: 'pi pi-eye-slash',
      iconColor: '#334155',
      iconBg: '#e2e8f0',
      description: 'Hide your company name and logo for\nsensitive hiring needs.',
    },
  ];

  dashboardFeatures = [
    { icon: 'bi-file-earmark-text', label: 'Smart Job Editor' },
    { icon: 'bi-funnel-fill', label: 'Candidate Filtering' },
    { icon: 'bi-bar-chart-line-fill', label: 'Post Analytics' },
    { icon: 'bi-camera-video-fill', label: 'AI Interviews' },
    { icon: 'bi-check2-circle', label: 'Application Tracker' },
  ];
}